export const projectData = {
    "Projects": [
        {
            "Nombre":"Cabo Verde",
            "Slug":"General View",
            "Icono": require("./../UI/Logos/LogosProyectos/Proyecto.svg"),
            "IconoSelected": require("./../UI/Logos/LogosProyectos/Proyecto_White.svg"),
        },
        {
            "Nombre":"Antao",
            "Slug":"Antao",
            "Icono": require("./../UI/Logos/LogosProyectos/Proyecto.svg"),
            "IconoSelected": require("./../UI/Logos/LogosProyectos/Proyecto_White.svg"),
            "id":"636516d91f350d00188e98cc",
            "path": "/Constructoras/Oikos/Antao",
            "Modules": [
                {
                    "Name":"Vías",
                    "slug":"vias"
                },
                {
                    "Name":"Beneficios",
                    "slug":"beneficios"
                },
                {
                    "Name":"Amenidades",
                    "slug":"amenidades"
                },
                {
                    "Name":"Etapas",
                    "slug":"etapas"
                }
            ]
        },
        {
            "Nombre":"Porto Novo",
            "Slug":"Porto Novo",
            "Icono": require("./../UI/Logos/LogosProyectos/Proyecto.svg"),
            "IconoSelected": require("./../UI/Logos/LogosProyectos/Proyecto_White.svg"),
            "id":"63654b441f350d00188ea7b1",
            "path": "/Constructoras/Oikos/Portonovo",
            "Modules": [
                {
                    "Name":"Vías",
                    "slug":"vias"
                },
                {
                    "Name":"Beneficios",
                    "slug":"beneficios"
                },
                {
                    "Name":"Amenidades",
                    "slug":"amenidades"
                },
                {
                    "Name":"Etapas",
                    "slug":"etapas"
                },
                {
                    "Name":"Ayuda",
                    "slug":"ayuda"
                }
            ]
        }
    ]
}